import type { ReactNode } from "react";
import clsx from "clsx";
import { Card } from "@/components/ui/Card";

export interface TableProps {
  children: ReactNode;
  className?: string;
  wide?: boolean;
  responsive?: boolean;
  emptyMessage?: string;
  isEmpty?: boolean;
  /** Bleibt sichtbar, auch wenn die Tabelle leer ist (Suche, Zähler). */
  toolbar?: ReactNode;
}

export function Table({
  children,
  className,
  wide,
  responsive = true,
  emptyMessage,
  isEmpty,
  toolbar,
}: TableProps) {
  return (
    <Card bodyClassName="p-0 overflow-hidden">
      {toolbar}
      {isEmpty && emptyMessage ? (
        <p className="eh-table-empty">{emptyMessage}</p>
      ) : (
        <div className={clsx("eh-table-scroll", responsive && "eh-table-scroll--responsive")}>
          <table
            className={clsx(
              "eh-table text-left",
              wide && "eh-table--wide",
              responsive && "eh-table--responsive",
              className,
            )}
          >
            {children}
          </table>
        </div>
      )}
    </Card>
  );
}
